import styled from 'styled-components';

export const Main = styled.main`
  flex: 1 0 auto;
`;

export const Container = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-flow: column;
`;
